import React from 'react';
export var Loading = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 24 : _b;
    return (React.createElement("span", { style: {
            width: size,
            marginRight: '0.2rem',
        } },
        React.createElement("svg", { width: size, height: size, className: "spinner", viewBox: "0 0 50 50", style: { display: 'inline', verticalAlign: 'middle' } },
            React.createElement("circle", { cx: "25", cy: "25", r: "20", fill: "none", className: "path" }))));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/MultiSelect/multi-select/Loading.tsx
// module id = 1190
// module chunks = 0